import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Camera, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { SectionTitle } from './Sections2027';
import { galeriaApi } from '../../lib/api';

const API = process.env.REACT_APP_BACKEND_URL || '';

export const MemoriasSection = () => {
  const [albuns, setAlbuns] = useState([]);

  useEffect(() => {
    galeriaApi.publica().then((r) => setAlbuns(r.data.flatMap((e) => e.albuns.map((a) => ({ ...a, ano: e.ano }))))).catch(() => {});
  }, []);

  const comFotos = albuns.filter((a) => a.capa_url);

  return (
    <section id="memorias" className="py-24 bg-obsidian scroll-mt-20" data-testid="memorias-section">
      <div className="container mx-auto px-4">
        <SectionTitle eyebrow="MEMÓRIAS DO KAIRÓS" icon={Camera} title={<>Kairós 2026 — momentos que <span className="text-kairos-orange">ficaram para sempre</span></>} subtitle="Quatro dias de aprendizado, emoções, reencontros e fortalecimento dos laços matrimoniais. Reviva alguns dos momentos especiais que fizeram parte desta edição." />
        {comFotos.length > 0 && (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 max-w-5xl mx-auto mb-10">
            {comFotos.slice(0, 4).map((a) => (
              <Link key={a.album_id} to={`/memorias/${a.album_id}`} className="group relative aspect-[4/3] rounded-xl overflow-hidden border border-white/10 hover:border-kairos-orange/40 transition-colors" data-testid={`memorias-preview-${a.album_id}`}>
                <img src={`${API}${a.capa_url}`} alt={a.titulo} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <p className="absolute bottom-3 left-3 right-3 text-white text-sm font-medium">{a.titulo}<span className="block text-gray-400 text-xs">{a.total_fotos} fotos</span></p>
              </Link>
            ))}
          </div>
        )}
        <div className="text-center">
          <Link to="/memorias" data-testid="memorias-cta">
            <Button variant="outline" className="h-12 px-8 rounded-full border-kairos-orange/50 text-kairos-orange hover:bg-kairos-orange/10 hover:text-white font-semibold">
              Conhecer os momentos do Kairós 2026 <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
